import type { IAudit } from '@ifs-gcp/core';

import { getBtoa } from './getBtoa';

export const createAuditFileBtoa = (audit: IAudit) => {
  return getBtoa(audit.toIfsFile());
};
